<script>
	//svelte basics
	import { onMount } from 'svelte';

	//util functions
	import { formatAmount, validateSupporter } from './util.js';
	import { submitting } from './stateStore.js'


	//components
	import AddCard  from './AddCard.svelte';
	import Footer from './Footer.svelte';

	//data
	import { donorFields, strings, amounts } from './data.js';


	//set lang based on url
	const lang = window.location.host.includes('amis') && 'fr' || 'en';

	//state vars that get passed to AddCard to manage button disabling and err message display
	let errorMessage = null;


	$: {
		if ( lang == 'fr' ) {
			document.title = "Faites un don !"
		} else {
			document.title = "Donate to FRIENDS!"
		}
	}


	//4 step process. Start at step 1
	let step = 1;

  let logo_url = strings[lang].logo_url;



  function which_logo(step) {
    console.log(step);
    document.body.setAttribute('data-step', 'step' + step);
    if(step === 2 || step === 1) {
      logo_url = strings[lang].logo_url;
	  }

		if(step === 3) {
  	  logo_url = strings[lang].logo_on_red_url;
	  }

	  if(step === 4) {
  	  logo_url = strings[lang].logo_on_dark_url;
	  }
  }

	//increment step
	function nextStep(e) {

		e.preventDefault();
		step ++;

		which_logo(step);
	}

	//maing submit handler. Accepts token passed by AddCard onComplete callback
	function processDonation(token) {
	fetch(`https://pay.friends.ca/submit-donation`, {
			method: 'post',
			body: JSON.stringify({
				supporterData: data.supporterData,
				type: data.frequency,
				amount: data.amount,
				token,
				lang
			}),
			// Adding headers to the request
		  headers: {
				"Content-type": "application/json; charset=UTF-8"
		  }
		})
		.then(r => {
				//set submitting to false if we have a response
				$submitting = false;
				return r.json();
		})
		.then(data => {
			//prpobably redundant but this wasn't working consistently, keeping
			//dontae button locked on error
			$submitting = false;

			//show an error if there is one
			if ( data.statusCode !== 200 || !!data.error ) {
				console.log('error is here', data.error);
				errorMessage = data.message;
			} else {
				//otherwise proceed to thank you
				step++;
			}
		}).catch(e => {
			console.log('error is here', e);
			//handle throws
			$submitting = false;
			errorMessage = e.message;
		})
	}

	//this is what gets submitted. All form inputs bind to this
	let data = {
		frequency: 'single',
		amount: 50,
		supporterData: {}
	}

</script>
<div class="outer-wrap d-flex flex-column h-100 p-3 step-{step}">
<main>
	<div class="container donate-form-wrapper mb-5">
		 <div class="row ">
			 <div class="col-12">
			 		<!-- Show the main heading on Step 1 ony -->
					 {#if step == 1}
							<div class="form-lead">
  							<h1 class="p text-center" id="donateModalLabel">{strings[lang].contribute_label}</h1>
  							<p id='intro_line' class='text-center'>{strings[lang].intro_line}</p>
							</div>
							<!-- Show back on steps 2, and 3 only, not 1 or 4 -->
							{:else if step < 4}
							<div class="text-center mb-4">
							<a href={'#'} class='next' style='color: #a8a8a8; font-size: 0.75rem;' on:click={function (e) {
								e.preventDefault();
								step--;
  							which_logo(step);
							 }}
							>← {strings[lang].previous}</a>
							</div>
						{/if}

						<!-- Except on final page, show journey progress -->
						{#if step < 4}
							<p class='red form-step-heading text-center all-caps'><span class='red'>{strings[lang].step}</span> <span class='red'> {step}/3</span> <br/>{strings[lang].stepNames[step - 1]}</p>
						{/if}
			 </div>
		 </div>

		 <!-- STEP 1 -->
		 {#if step == 1}

		   <p>{strings[lang].frequency}</p>
			 <div class='row' >
					<div class='col-12 col-md-6 mb-4'>

						<div
							on:click={function (e) { data.frequency = 'single'; }}
							class={ 'button outline ' +  (data.frequency == 'single' && 'active' || '') }
						>{strings[lang].single_gift}</div>

					</div>

					<div class='col-12 col-md-6 mb-4'>
						<div
							on:click={function (e) { data.frequency = 'monthly'; }}
							class={ 'button outline ' + (data.frequency == 'monthly' && 'active' || '') }
						>{strings[lang].monthly_support}</div>

					</div>
			 </div>

			 <p>{strings[lang].amount}</p>
		 	<div class='row'>
				<!-- Show amounts for the frequency of donation. Presents can be changed by changing amounts in data.js -->
				 {#each amounts[data.frequency] as amount}
		        <div class='col-6 col-md-3 mb-4'>
		         <div
		           class={ 'button outline text-center ' +  (data.amount == amount && 'active' || '') }
		           on:click={(e) => { data.amount = amount; }}
		         >{formatAmount(amount, lang)}</div>

		       </div>
		     {/each}

		   </div>
			 <!-- Other -->
		   <div class='row' style="text-align: left">
		     <div class='col-6 mb-4'>
		      <input type='number' class='outline' placeholder={strings[lang].other} on:change={(e) => {data.amount = e.target.value}} />
		    </div>
				<!-- Next -->
				<div class='col-6 mb-4 next-step-wrap d-flex flex-row align-items-end justify-content-end' style='text-align: right;'>
					<a class='next' href={'#'} style='margin-top: 20px;' on:click={nextStep}>{strings[lang].next} →</a>
					</div>
		   </div>
		{/if}

		<!-- STEP 2, donor fields -->
		{#if step == 2}
			<div class='row'>
				{#each donorFields as {name, required, placeholder}  }
					<div class='col-12 col-md-6 mb-3' style='text-align: left;'>
						<label style='margin-bottom: 5px;' for={name} class={!!required && 'required' || ''}>{placeholder[lang]}{#if required}*{/if}</label>

						<!-- Province is a select box, everything else is an input -->
						{#if name !== 'province'}
							<input name={name}  placeholder={placeholder[lang]} class='outline w-100 form-control' bind:value={data.supporterData[name]}/>
						{:else}
						  <select bind:value={data.supporterData.province} class='outline form-control'>
							 <option></option>
							 <option value="AB">Alberta</option>
							 <option value="BC">British Columbia</option>
							 <option value="PE">Prince Edward Island</option>
							 <option value="MB">Manitoba</option>
							 <option value="NB">New Brunswick</option>
							 <option value="NS">Nova Scotia</option>
							 <option value="ON">Ontario</option>
							 <option value="QC">Québec</option>
							 <option value="SK">Saskatchewan</option>
							 <option value="NL">Newfoundland and Labrador</option>
							 <option value="NU">Nunavut</option>
							 <option value="NT">Northwest Territories</option>
							 <option value="YT">Yukon</option>
						  </select>
						{/if}
					</div>
				{/each}
			</div>
			<div class='row'>
			<!-- Opt in -->

				<div class='col-12' style='text-align: left !important'>
  				<p class="mb-0">{strings[lang].communications}</p>
					<div class="">
	          	<label for="communications-checkbox" style='line-height: 1.1; display: flex; flex-direction: row !important; align-items: center; margin-bottom: 0.5rem;'>
	            	<input style='width: 50px; height: 50px; margin-right: 1rem;' id="communications-checkbox" type="checkbox"  bind:checked={data.supporterData.optIn}>
								{strings[lang].optIn}*
							</label>
	        </div>
				</div>
			</div>
			<div class='row'>
				<div class='col-12 text-right'>
				<!-- Validate before continuing -->
					<a
						class='next'
						href={'#'}
						style='margin-top: 20px;'
						on:click={function (e) {
							const isValid = validateSupporter(data.supporterData, donorFields, lang, strings);
							if ( !isValid ) {
								return;
							}
							nextStep(e);
						}}
						>{strings[lang].next} →</a>
				</div>
			</div>
		{/if}

		<!-- Step 3 -->
		{#if step == 3}
			<div class='row'>
				<div class='col-12 text-center'>
				<!-- Donation summary -->
					<p class="mb-0">{strings[lang].your_donation}</p>

					<div class="your-contribution-text lead mb-3">
						{#if data.frequency === 'single'}
							<span>{strings[lang].single_gift}</span>
						{:else}
							<span>{strings[lang].monthly_support}</span>
						{/if}
					 {#if lang == 'en'}of{:else}de{/if}
					 {formatAmount(data.amount, lang)}
					</div>



				</div>
			</div>
			<!-- Add card component with stripe elements -->
			<AddCard submitText={strings[lang].submit_text} errorMessage={errorMessage} onComplete={processDonation} label={strings[lang].add_card_label} locale={lang == 'en' && 'en_CA' || 'fr-CA'} />
		{/if}

		<!-- Confirmation message -->
		{#if step == 4}
		<div class='container'>
			<div class='row'>
					<div class='col-12 text-center'>
  					<p class="lead mb-4">{strings[lang].donation_complete}</p>
  					<h1 class="massive red">{strings[lang].thank_you}</h1>
						<p>{strings[lang].thank_you_message}</p>
					</div>
			</div>
		</div>

		{/if}
	</div>
</main>


<!-- Footer -->
<Footer step={step} message={strings[lang].footer} logoUrl={ logo_url }/>
<!-- Some global styles -->
</div>
